import { render } from "./TaskTypeTag.vue?vue&type=template&id=70f7db11"
import script from "./TaskTypeTag.vue?vue&type=script&lang=js"
export * from "./TaskTypeTag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__